import { fetchOrganizationRequest, fetchOrganizationSuccess, fetchOrganizationFailer } from './OrganisationAction'

import DataService from '../../../../../../../Service';

export const fetchOraganization = (params: any) => {
    return (dispatch: any) => {
        dispatch(fetchOrganizationRequest());

        DataService.getData(params, 'report_fetch_oraganization').then((res) => {
            if (Boolean(res?.success)) {
                dispatch(fetchOrganizationSuccess(res?.collate_feedbacks));
            }
        }).catch((error) => {
            dispatch(fetchOrganizationFailer(error));
        })
    }
}
